import { Flex } from "@p0security/ui";

export const PermissionTitle: React.FC<{ title: string }> = ({ title }) => (
  <div className="flex flex-col">
    <div>{title}</div>
    <Flex className="text-[small] font-normal whitespace-nowrap">
      used / unused / unknown
    </Flex>
  </div>
);
